import { Experience } from "@/models/Product";

export const experiencesMock: Experience[] = [
  {
    id: "ex-1",
    title: "Zbor de Agrement București",
    description: "Experimentează senzația zborului deasupra Bucureștiului. Zbor de 30 de minute cu un instructor experimentat.",
    price: 250,
    images: ["https://images.unsplash.com/photo-1436491865332-7a61a109db05?w=800"],
    category: "experiences",
    subcategory: "Zbor de agrement",
    sellerId: "s1",
    sellerName: "SkyTraders Aviation",
    createdAt: "2026-01-20",
    location: "București, România",
    status: "available",
    duration: "30 min",
    experienceType: "Zbor de agrement",
  },
  {
    id: "ex-2",
    title: "Salt cu Parașuta Tandem",
    description: "Salt cu parașuta tandem de la 4000m altitudine. Include instruire la sol și certificat.",
    price: 850,
    images: ["https://images.unsplash.com/photo-1521673461164-de300ebcfb17?w=800"],
    category: "experiences",
    subcategory: "Salt cu parasuta",
    sellerId: "s2",
    sellerName: "EuroAvion SRL",
    createdAt: "2025-12-15",
    location: "Cluj-Napoca, România",
    status: "available",
    duration: "3 ore",
    experienceType: "Salt cu parasuta",
  },
  {
    id: "ex-3",
    title: "Zbor Acrobatic Extra 300",
    description: "Experimentează manevre acrobatice într-un Extra 300. Looping, barrel roll, și tonneaux.",
    price: 500,
    images: ["https://images.unsplash.com/photo-1559628233-100c798642d4?w=800"],
    category: "experiences",
    subcategory: "Zbor de acrobatie",
    sellerId: "s3",
    sellerName: "RotorWing Romania",
    createdAt: "2026-02-05",
    location: "Brașov, România",
    status: "available",
    duration: "20 min",
    experienceType: "Zbor de acrobatie",
  },
  {
    id: "ex-4",
    title: "Zbor cu Balonul în Transilvania",
    description: "Zbor cu balonul cu aer cald deasupra Transilvaniei. Include mic dejun și toast cu șampanie.",
    price: 650,
    images: ["https://images.unsplash.com/photo-1507608616759-54f48f0af0ee?w=800"],
    category: "experiences",
    subcategory: "Zbor cu balonul",
    sellerId: "s2",
    sellerName: "EuroAvion SRL",
    createdAt: "2025-11-25",
    location: "Sibiu, România",
    status: "available",
    duration: "1.5 ore",
    experienceType: "Zbor cu balonul",
  },
];
